import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import SearchMdIcon from '../../assets/icons0/search-md.svg';
import classNames from 'classnames';
import searchFilter from '../../searchFilter';

const SearchBtn = ({menuFlag}) => {
    const location = useLocation();
    return (
        <Link className={classNames({'visibility-hidden': menuFlag, 'mw768-visibility-visible': true})} to={`/events${searchFilter(location.search, {search: true})}`}>
            <div className='height-2dot5rem width-2dot5rem display-flex justify-content-center align-items-center position-relative'>
                <SearchMdIcon className='display-block height-1dot5rem width-1dot5rem color-gray-600'/>
            </div>
        </Link>
    )
};

export default React.memo(SearchBtn);